import type { FleetAuthorizationStatus } from '@goelectric/shared-types';

/**
 * Mensajes compartidos de la UI de Flotas (US-2.3, ADR 0047).
 *
 * Centralizados para que la ficha, la tabla y el modal de vehículo expliquen la misma
 * restricción cuando la flota está inactiva y para el aviso de reconciliación RFID.
 */

/** Aviso al intentar una acción que el backend rechaza con la flota inactiva. */
export const FLEET_INACTIVE_HINT =
  'La flota está inactiva; reactívala desde la ficha de la flota.';

/** Aviso cuando el RFID de un vehículo no está replicado en todos los tenants. */
export const FLEET_RECONCILIATION_MESSAGE =
  'El RFID no está replicado en todos los tenants; requiere reconciliación.';

/**
 * `true` si la autorización RFID requiere reconciliación (replicación parcial o error).
 * En ese caso la mutación fue aceptada por el backend pero NO es un éxito pleno.
 */
export function requiresFleetReconciliation(
  status: FleetAuthorizationStatus,
): boolean {
  return status === 'PARTIAL' || status === 'ERROR';
}
